import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Slide from '@mui/material/Slide';
import styles from './index.module.sass';
import WATERMARK from '../../images/sign/terramar-letras-marca-de-agua.png';
// Queries
import getOlvidoSuPsw from '../Queries/getOlvidoSuPsw.js';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

export default function ForgotPassword({
  history,
  webservice,
  setActualPage,
  getCookie,
  screenSize,
}) {
  const [form, setForm] = useState({ usuario: '', email: '' });
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation('forgotPassword');
  const [selectType, setselectType] = useState('user');
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState('');

  const handleChange = (e, type) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  async function sendForm(e) {
    if (form.kit === '' && selectType === 'user') {
      setAlertText(t('alert1'));
      setOpen(true);
      return;
    }

    if (form.mail === '' && selectType === 'mail') {
      setAlertText(t('alert2'));
      setOpen(true);
      return;
    }

    setLoading(true);
    const response = await getOlvidoSuPsw({ form });

    if (response.tipoMensaje === 'error') {
      setAlertText(response.mensaje);
      setOpen(true);
      setLoading(false);
    } else {
      setAlertText(response.mensaje);
      setOpen(true);
      setLoading(false);
      setTimeout(() => history.push('/'), 4000);
    }
  }

  function handleRadioChange(type) {
    setselectType(type);
    setForm({
      usuario: '',
      email: '',
    });
  }

  return (
    <form
      className={`${styles.formContainer} ${styles[screenSize]}`}
      style={{
        backgroundImage: `url(${WATERMARK})`,
      }}>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpen(false)}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'>
        <DialogContent>
          <div className={styles.dialogContent}>
            <div className={styles.dialogTitle}>{t('dialogTitle')}</div>
            {alertText}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <div className={styles.instructions}>
        <div className={styles.inputLabel}>{t('title')}</div>
        <div className={styles.textInstructions}>
          {t('instructions')} <br /> {t('select')}:
        </div>
        <div>
          <input
            type='radio'
            value='user'
            name='radio'
            id='user'
            onClick={(e) => handleRadioChange('user')}
            defaultChecked
          />
          <label className={styles.label}>{t('user')}</label>
          &nbsp;&nbsp;
          <input
            type='radio'
            value='correo'
            name='radio'
            id='mail'
            onClick={(e) => handleRadioChange('mail')}
          />
          <label className={styles.label}>{t('mail')}</label>
        </div>
      </div>

      <div className={styles.formContent}>
        {selectType === 'user' && (
          <div className={styles.inputContainer}>
            <div className={styles.inputLabel}>{t('user')}</div>
            <input
              type='text'
              className={styles.inputText}
              name='usuario'
              value={form.usuario}
              onChange={(e) => handleChange(e)}
            />
          </div>
        )}

        {selectType === 'mail' && (
          <div className={styles.inputContainer}>
            <div className={styles.inputLabel}>{t('mail')}</div>
            <input
              className={styles.inputText}
              type='text'
              name='email'
              value={form.email}
              placeholder='example@terramar.com'
              onChange={(e) => handleChange(e)}
            />
          </div>
        )}

        <Button
          type='button'
          variant='contained'
          size='large'
          color='primary'
          className={styles.button}
          onClick={(e) => sendForm(e)}>
          {(loading && <CircularProgress className={styles.circularProgress} />) ||
            t('titleButton')}
        </Button>
        <div className={styles.forgotPassword} onClick={() => history.push('/')}>
          {t('return')}
        </div>
      </div>
    </form>
  );
}
